import { createFeatureSelector } from '@ngrx/store';
import { handleActions } from 'redux-actions';
import {
  IEntityList,
  IFilteredLists,
  initialListState,
} from '../entity-data/entity-data.reducer';
import { EntityTypesEnum } from '../../app.enum';
import {
  documentReducerMap,
  IDocumentState,
} from '../document-data/document-data.reducer';
import { DEFAULT_SEARCH_PARAMS } from './purchase-order-data.data';

// feature name
export const FEATURE_NAME = 'purchase-order-data';

// state interface
export interface IState extends IDocumentState {}

// initial state of store
export const initialDocumentListState: IEntityList = {
  ...initialListState,
  searchParams: DEFAULT_SEARCH_PARAMS,
};

export const initialFilteredListsState: IFilteredLists = {
  all: initialDocumentListState,
  search: initialDocumentListState,
};

export const initialState: IState = {
  filteredLists: initialFilteredListsState,
  editingEntity: null,
  selectedEntities: null,
  masterError: null,
  dispatchedResponse: null,
  tmpCache: null,
};

// reducers
const reducerFn = handleActions(
  {
    ...documentReducerMap<IState>(),
  } as any,
  initialState
);

// filter actions by entityType
export function reducer(state: IState = initialState, action: any) {
  return action.payload &&
    action.payload.entityType === EntityTypesEnum.purchase_order
    ? reducerFn(state, action)
    : state;
}

// selectors
export const selectFeature = createFeatureSelector<IState>(FEATURE_NAME);
